import { Component, OnChanges, Input, ElementRef, SimpleChanges, OnInit } from '@angular/core';

import { ChartValue } from './chart-value.model';
import { ColorService } from "../../shared/color-service";
import { PieChartOptions } from "./pie-chart-options.model";

@Component({
    selector: 'pie-chart',
    template: `<div data-pie-chart></div>`
})
export class PieChartComponent implements OnChanges, OnInit {
    @Input() chartValues: ChartValue[];
    @Input() forceChange: any;
    @Input() options: PieChartOptions;
    private _options: PieChartOptions;

    constructor(private el: ElementRef, private colorService: ColorService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.chartValues) {
            this._options = this.options;
            let plotArea = $(this.el.nativeElement).find('[data-pie-chart]').empty();
            $(this.el.nativeElement).find('[data-pie-chart]').height(this._options.height);
            this._options.legend = {
                show: true,
                container: $(this.options.legendSelector)
            };
            if (this._options.needRemainingPercentage) {
                this.calculateRemainingPercentage(plotArea);
            }
            let labels = this.chartValues.map(s => s.label);
            if (labels)
                this._options.colors = this.colorService.getColorsByNames(labels);
            $.plot(plotArea, this.chartValues, this._options);

        }
    }

    ngOnInit(): void {
        if (this.options.tooltip) {
            this.initToolTip();
        }
    }

    private calculateRemainingPercentage(plotArea: any): void {
        let item = this.chartValues[0];
        let chartvalue = new ChartValue("", [100 - item.data[0]], item.identifier)
        this.chartValues.push(chartvalue);
        this._options.legend = {
            show: true,
            container: $(plotArea.closest('[data-container]').find(this._options.legendSelector))
        };
        this._options.series = {
            pie: {
                innerRadius: .5,
                show: true,
                stroke: {
                    color: "#222a33"
                },
                label: {
                    show: true,
                    radius: 0,
                    formatter: function labelFormatter(series) {
                        return "<div>" + Math.round(item.data[0].toFixed(2)) + "%" + "</div>";
                    }
                }
            }
        };
    }

    private initToolTip(): void {
        $(this.el.nativeElement).on("plothover", (event, pos, item) => {
            if (item) {
                $('span#tooltip').css({ "border-color": item.series.color });
                $('span#tooltip').css({ "border-left": "none" });
                let tooltipParent = $("span#tooltip").parent();
                //if the piechart is too close to the right edge of the screen => display the tooltips to the left
                if ($(window).width() - pos.pageX <= 100) {
                    $('span#tooltip > #triangle').remove();
                    $('span#tooltip > #triangle-small').remove();
                    $('span#tooltip').append('<span id="triangle-br"></span> <span id="triangle-small-br"></span>');
                    $('span#tooltip > #triangle-br').css({ "border-color": item.series.color });
                    $('span#tooltip > #triangle-small-br').css({ "border-color": item.series.color, "height": "15px", "z-index": 101 });
                    //set top & left values for tooltip div from the position of the cursor
                    $(tooltipParent).css({ "left": pos.pageX - $('span#tooltip').width() - 20, "top": pos.pageY - 50 });
                    let parentWidth = $('span#tooltip').width();
                    let contentWidth = $('span#tooltip > #triangle-small-br').width();
                    let extraWidth = $('span#tooltip > #triangle-br').width();
                    let customBorder = 4;
                    $('span#tooltip > #triangle-small-br').css({ 'left': customBorder + parentWidth + extraWidth - contentWidth });
                } else {
                    $('span#tooltip > #triangle').css({ "border-color": item.series.color });
                    $('span#tooltip > #triangle-small').css({ "border-color": item.series.color });
                    //set top & left values for tooltip div from the position of the cursor
                    $(tooltipParent).css({ "left": pos.pageX + 20, "top": pos.pageY - 50 });
                }
            } else {
                $("#tooltip").hide();
            }
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/dashboard/chart/pie-chart.component.ts